module.exports = __webpack_public_path__ + "img/certik-dark.fd56dc2c.png";